module.exports = __webpack_public_path__ + "img/faq.7f45a361.svg";